import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { loginUser, clearRedux } from "../redux/slices/authSlice";
import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleLoginButton from "../components/method-login/google-login";
import FacebookLoginButton from "../components/method-login/facebook-login";
import { toast } from "react-toastify";
const LoginPage = () => {
  const dispatch = useDispatch();
  const { user, loading, error, authSource } = useSelector(
    (state) => state.auth
  );
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    dispatch(clearRedux());
    if (user && !authSource) {
      toast.success("Đăng nhập thành công");
      queueMicrotask(() => navigate("/"));
    }
  }, [user, navigate]);

  // State lưu dữ liệu nhập
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  // State lưu lỗi validation
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  // Xử lý thay đổi input
  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });

    // Xóa lỗi khi người dùng nhập lại
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
    if (error) {
      dispatch(clearRedux()); // Thêm action để reset error trong Redux
    }
  };

  // Xử lý submit form
  const handleSubmit = (e) => {
    e.preventDefault();

    // Kiểm tra lỗi input trước khi gửi API
    let newErrors = {};
    if (!credentials.email.trim())
      newErrors.email = "Email không được để trống!";
    if (!credentials.password.trim())
      newErrors.password = "Mật khẩu không được để trống!";

    // Nếu có lỗi, cập nhật state và không gửi API
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    dispatch(loginUser(credentials)); // Gửi API login
    // Nếu đã login → Chuyển hướng về Home
  };

  return (
    <>
      <div className="main-wrapper authentication-wrapper">
        <div className="container-fuild">
          <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
              <div className="col-xxl-4 col-lg-6 col-md-6 col-11 mx-auto">
                <div
                  className="p-4 text-center"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src="assets/img/logo-dark.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="card authentication-card">
                  <div className="card-header">
                    <div className="text-center">
                      <h5 className="mb-1">Đăng nhập</h5>
                      <p>DreamsTour – Biến ước mơ du lịch thành hiện thực!</p>
                    </div>
                  </div>
                  <div className="card-body">
                    {/* Input Email */}
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <div className="input-icon position-relative">
                        <span className="input-icon-addon">
                          <i className="isax isax-message"></i>
                        </span>
                        <input
                          type="email"
                          name="email"
                          value={credentials.email}
                          onChange={handleChange}
                          className={`form-control form-control-lg`}
                          placeholder="Nhập email"
                          required
                        />
                        {/* Icon cảnh báo lỗi */}
                        {errors.email && (
                          <span className="position-absolute end-0 top-50 translate-middle-y pe-3">
                            <i className="text-danger bi bi-exclamation-circle-fill"></i>
                          </span>
                        )}
                      </div>
                      {errors.email && (
                        <span className="text-danger">
                          <i className="isax isax-info-circle"></i>{" "}
                          {errors.email}
                        </span>
                      )}
                    </div>

                    {/* Input Password */}
                    <div className="mb-3">
                      <label className="form-label">Mật khẩu</label>
                      <div className="input-icon">
                        <span className="input-icon-addon">
                          <i className="isax isax-lock"></i>
                        </span>
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          value={credentials.password}
                          onChange={handleChange}
                          className={`form-control form-control-lg`}
                          placeholder="Nhập mật khẩu"
                          required
                        />
                        <span
                          className="input-icon-addon toggle-password"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer" }} // Để icon có thể click
                        >
                          <i
                            className={
                              showPassword
                                ? "isax isax-eye"
                                : "isax isax-eye-slash"
                            }
                          ></i>
                        </span>
                      </div>
                      {errors.password && (
                        <span className="text-danger">
                          <i className="isax isax-info-circle"></i>{" "}
                          {errors.password}
                        </span>
                      )}
                    </div>

                    {/* Hiển thị lỗi từ Redux */}
                    {error && (
                      <p className="text-danger">
                        <i className="fas fa-times-circle me-1"></i> {error}
                      </p>
                    )}
                    <div className="mt-3 mb-3">
                      <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2">
                        <div className="form-check d-flex align-items-center mb-2">
                          {/* <input
                            className="form-check-input mt-0"
                            type="checkbox"
                            value=""
                            id="remembers_me"
                          />
                          <label
                            className="form-check-label ms-2 text-gray-9 fs-14"
                            for="remembers_me"
                          >
                            Remember Me
                          </label> */}
                        </div>
                        <Link
                          to="/forgot-password"
                          className="link-primary fw-medium fs-14 mb-2"
                        >
                          Quên mật khẩu?
                        </Link>
                      </div>
                    </div>

                    {/* Submit Button */}
                    <div className="mb-3">
                      <button
                        type="submit"
                        className="btn btn-xl btn-primary d-flex align-items-center justify-content-center w-100"
                        onClick={handleSubmit}
                        disabled={loading} // Vô hiệu hóa nút khi đang gửi yêu cầu
                      >
                        {loading && !authSource ? (
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                          ></span>
                        ) : (
                          <>
                            Đăng nhập
                            <i className="isax isax-arrow-right-3 ms-2"></i>
                          </>
                        )}
                      </button>
                    </div>

                    {/* Social Login */}
                    <div className="login-or mb-3">
                      <span className="span-or">Hoặc</span>
                    </div>
                    <div className="d-flex align-items-center mb-3">
                      <GoogleOAuthProvider
                        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                      >
                        <GoogleLoginButton />
                      </GoogleOAuthProvider>
                      <FacebookLoginButton />
                    </div>

                    <div className="d-flex justify-content-center">
                      <p className="fs-14">
                        Bạn chưa có tài khoản?{" "}
                        <Link to="/register" className="link-primary fw-medium">
                          Đăng ký
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="coprright-footer">
          <p className="fs-14">
            Copyright &copy; 2025. All Rights Reserved,{" "}
            <a href="#" className="text-primary fw-medium">
              DreamsTour
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
